import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StateService } from './services/state.service';

export const callbackGuard: CanActivateFn = async () => {
  const authService = inject(StateService);
  const router = inject(Router);

  if (authService.getUserState()) {
    await router.navigate(['/home']);
    return false;
  } else {
    await router.navigate(['/']);
    return false;
  }
};
